<script lang="ts">
  export let src: string;
  export let alt: string = '';
  export let round: boolean = false;
</script>

<img {src} {alt} class:round />

<style lang="scss">
  img {
    max-width: 100%;

    &.round {
      border-radius: 50%;
    }
  }
</style>
